$(document).ready(function () {
  var giftReady = false;

  window.initGift = function (form) {
    var $form = $(form);

    var $toggle = $form.find(".js-giftToggle");
    var $input = $form.find(".js-giftInput");
    var $submit = $form.find(".js-giftSubmit");

    $toggle.on("click", function (ev) {
      ev.preventDefault();
      $(".js-giftModal").toggleClass("active");
    });

    $input.on("keydown", function (ev) {
      if ($(this).val()) {
        $(".js-giftSubmit").removeClass("disabled");
      }
    });

    $input.on("keyup", function (ev) {
      if ($(this).val()) {
        $(".js-giftSubmit").removeClass("disabled");
      } else {
        $(".js-giftSubmit").addClass("disabled");
      }
    });

    $input.on("change", function (ev) {
      if ($(this).val()) {
        $(".js-giftSubmit").removeClass("disabled");
      } else {
        $(".js-giftSubmit").addClass("disabled");
      }
    });

    $submit.on("click", function (ev) {
      ev.preventDefault();
      var attributes = "attributes[Gift Note]=" + $(".js-giftInput").val();
      jQuery.post("/cart/update.js", attributes).done(function (response) {
        $(".js-gift").addClass("state--has-note");
        $(".js-giftModal").removeClass("active");
      });
    });

    console.log("gift innited", $form);
  };

  window.checkforGift = function (form) {
    var $form;

    if (form) {
      $form = $(form);
    } else {
      $form = $(".js-cartForm");
    }

    setTimeout(function () {
      var giftToggle = $form.find(".js-giftToggle");
      if (giftToggle && giftToggle !== "undefined") {
        giftReady = true;
        window.initGift($form);
      } else {
        console.log("Checking for gift...");
      }
      if (giftReady === false) checkforGift();
    }, 250);
  };

  window.initGift($(".js-cartForm"));
});
